import styled from "styled-components";

import React, { useEffect, useRef, useState } from "react";
import { SimpleSelect1 } from "../../SimpleSelect/SimpleSelect1";
import { InputField1 } from "../../InputField1/InputField1";
import { RowLayoutStyle, RowElement } from "./AddSlide";

const SlideImageSelector = ({
  newSlide,
  handleChange,
  setSlideMode,
  sliderOption,
  resetInputFile,
  handleChangeMode,
  defaultLocation,
  slideKeys,
  slideMode,
}) => {
  const SELECT_STATUS_MODE = {
    TOP_SLIDER: "TOP_SLIDER",
    CENTER_SLIDER: "CENTER_SLIDER",
    BOTTOM_COLOR_SLIDER: "BOTTOM_COLOR_SLIDER",
  };

  const selectOptions = [
    { value: "TOP_SLIDER", label: "اسلایدر بالا" },
    { value: "CENTER_SLIDER", label: "اسلایدر وسط" },
    { value: "BOTTOM_COLOR_SLIDER", label: "نوار رنگی پایین" },
  ];

  const SELECT_MODE_TITLE = {
    top: {
      titleImg: "صرفا تصاویر 1008 * 448 پیکسل",
      subTitleImg: "صرفا تصاویر 168 * 374 پیکسل",
    },
    main: {
      titleImg: "صرفا تصاویر 197 * 316 پیکسل",
      subTitleImg: "صرفا تصاویر 112 * 181 پیکسل",
    },
    bottom: {
      titleImg: "صرفا تصاویر 660 * 240 پیکسل",
      subTitleImg: "صرفا تصاویر 112 * 183 پیکسل",
    },
    offer: {
      titleImg: "صرفا تصاویر 430 * 250 پیکسل",
      subTitleImg: "صرفا تصاویر 104 * 374 پیکسل",
    },
    "انتخاب کنید": {
      titleImg: "صرفا تصاویر 430 * 250 پیکسل",
      subTitleImg: "صرفا تصاویر 104 * 374 پیکسل",
    },
  };

  const [selectMode, setSelectMode] = useState(SELECT_STATUS_MODE.TOP_SLIDER);

  const photoRef = useRef();
  const smallPhotoRef = useRef();
  const enPhotoRef = useRef();
  const enSmallPhotoRef = useRef();
  const arPhotoRef = useRef();
  const arSmallPhotoRef = useRef();
  const modeSelectRef = useRef();

  const handleChangeSelectMode = (e) => {
    const { value } = e;
    setSelectMode(SELECT_STATUS_MODE[value]);
    setSlideMode(SELECT_STATUS_MODE[value]);
  };

  useEffect(() => {
    photoRef.current.value = "";
    smallPhotoRef.current.value = "";
    enPhotoRef.current.value = "";
    enSmallPhotoRef.current.value = "";
    arPhotoRef.current.value = "";
    arSmallPhotoRef.current.value = "";
  }, [resetInputFile]);

  return (
    <ImageSelectorStyle>
      <SimpleSelect1
        label={"انتخاب وضعیت"}
        onChange={handleChangeMode}
        inputRef={modeSelectRef}
        placeholder={
          defaultLocation && defaultLocation !== "undefined"
            ? slideKeys[defaultLocation]
            : "انتخاب کنید"
        }
        res={sliderOption ? sliderOption : []}
      />
      <RowLayoutStyle>
        <RowElement>
          <InputField1
            refInput={photoRef}
            type="file"
            name="slidePhoto"
            label={`تصویر فارسی (${SELECT_MODE_TITLE[slideMode]?.titleImg})`}
            onChange={handleChange}
            value={newSlide?.slidePhoto}
            placeholder="تصویر فارسی..."
            maxLength="50"
          />
        </RowElement>
        <RowElement>
          <InputField1
            type="file"
            refInput={enPhotoRef}
            name="en_slidePhoto"
            label={`تصویر انگلیسی (${SELECT_MODE_TITLE[slideMode]?.titleImg})`}
            onChange={handleChange}
            value={newSlide?.en_slidePhoto}
            placeholder="تصویر انگلیسی"
            maxLength="50"
          />
        </RowElement>
        <RowElement>
          <InputField1
            type="file"
            refInput={arPhotoRef}
            name="ar_slidePhoto"
            label={`تصویر عربی (${SELECT_MODE_TITLE[slideMode]?.titleImg})`}
            onChange={handleChange}
            value={newSlide?.ar_slidePhoto}
            placeholder="تصاویر عربی.."
            maxLength="50"
          />
        </RowElement>
      </RowLayoutStyle>

      <RowLayoutStyle>
        <RowElement>
          <InputField1
            type="file"
            name="mobileSlidePhoto"
            refInput={smallPhotoRef}
            label={`تصویر فارسی (${SELECT_MODE_TITLE[slideMode]?.subTitleImg})`}
            onChange={handleChange}
            value={newSlide?.mobileSlidePhoto}
            placeholder="عنوان فارسی..."
            maxLength="50"
          />
        </RowElement>
        <RowElement>
          <InputField1
            type="file"
            name="en_mobileSlidePhoto"
            refInput={enSmallPhotoRef}
            label={`تصویر انگلیسی (${SELECT_MODE_TITLE[slideMode]?.subTitleImg})`}
            onChange={handleChange}
            value={newSlide?.en_mobileSlidePhoto}
            placeholder="عنوان فارسی..."
            maxLength="50"
          />
        </RowElement>
        <RowElement>
          <InputField1
            type="file"
            name="ar_mobileSlidePhoto"
            refInput={arSmallPhotoRef}
            label={`تصویر عربی (${SELECT_MODE_TITLE[slideMode]?.subTitleImg})`}
            onChange={handleChange}
            value={newSlide?.ar_mobileSlidePhoto}
            placeholder="تصاویر عربی.."
            maxLength="50"
          />
        </RowElement>
      </RowLayoutStyle>
    </ImageSelectorStyle>
  );
};

const ImageSelectorStyle = styled.div``;

export default SlideImageSelector;
